<template>
  <div class="w-full">
    <div class="grow">
      <div class="flex items-center space-x-2 text-sm">
        <UAvatar :src="customer.image ?? undefined" :alt="customer.displayName" :text="customer.initials" size="sm" />
        <div>
          <p>
            <template v-if="customer.firstName?.length || customer.lastName?.length || customer.displayName?.length">
              {{ customer.displayName?.length ? customer.displayName : `${customer.firstName} ${customer.lastName}` }}
            </template>
            <template v-else>
              {{ $t('general.new') }}
            </template>
          </p>
          <p v-if="customer.company || customer.email || customer.phone" class="flex items-center space-x-2 text-gray-600 text-xs leading-none dark:text-gray-300">
            <span v-if="customer.company">{{ customer.company }}</span>
            <span v-if="customer.email">{{ customer.email }}</span>
            <span v-if="customer.phone">{{ customer.phone }}</span>
          </p>

          <div class="flex items-center flex-wrap mt-1">
            <o-chip v-if="customer.stats?.noShowRateIsHigh" flat variant="danger" size="xs" class="m-px">
              {{ $t('customer.highNoShow') }}
            </o-chip>
            <o-chip v-if="customer.stats?.cancellationRateIsHigh" flat variant="danger" size="xs" class="m-px">
              {{ $t('customer.highCancellation') }}
            </o-chip>
            <template v-if="customer.segments">
              <o-chip
                v-for="segment in customer.segments"
                :key="segment.idSegment"
                :variant="segment.variant"
                size="xs"
                class="m-px"
              >
                {{ segment.shortName }}
              </o-chip>
            </template>
            <customer-alerts :customer="customer" size="xs" />

            <template v-if="customer.isBirthdayToday">
              <UTooltip :text="$t('general.birthday', { name: customer.displayName })">
                <span class="text-lg">🎉</span>
              </UTooltip>
            </template>
          </div>
        </div>
      </div>
    </div>

    
  </div>
</template>

<script setup lang="ts">
import CustomerAlerts from './Alerts.vue'

import type { Customer } from '~/_api/models';

interface Props {
  customer: Customer
}

defineProps<Props>()
</script>
